import {
  ADD_PUBLISH,
  ADD_PUBLISH_SUCCESS,
  ADD_PUBLISH_FAILED,
  FETCH_PUBLISH,
  FETCH_PUBLISH_SUCCESS,
  FETCH_PUBLISH_FAILED,
  CLEAR_PUB_ERROR,
  ADD_PUBLISH_WEBSITE,
  ADD_PUBLISH_WEBSITE_SUCCESS,
  ADD_PUBLISH_WEBSITE_FAILED,
  FETCH_PUBLISH_WEBSITE,
  FETCH_PUBLISH_WEBSITE_SUCCESS,
  FETCH_PUBLISH_WEBSITE_FAILED,
  SYNC_TO_PROP24,
  SYNC_TO_PROP24_SUCCESS,
  SYNC_TO_PROP24_FAILED,
  SYNC_TO_PRIVATEPROP,
  SYNC_TO_PRIVATEPROP_SUCCESS,
  SYNC_TO_PRIVATEPROP_FAILED,
  SYNC_TO_WEBSITE,
  SYNC_TO_WEBSITE_SUCCESS,
  SYNC_TO_WEBSITE_FAILED,
  ADD_PRIVATE_PROP_PUBLISH,
  ADD_PRIVATE_PROP_PUBLISH_SUCCESS,
  ADD_PRIVATE_PROP_PUBLISH_FAILED,
  FETCH_PRIVATE_PROP_PUBLISH,
  FETCH_PRIVATE_PROP_PUBLISH_SUCCESS,
  FETCH_PRIVATE_PROP_PUBLISH_FAILED
} from "../store/types";

const INITIAL_STATE = {
  publish: null,
  webpublish: null,
  privateprop: null,
  loading: false,
  success: false,
  completed: false,
  portal: null, // ✅ NEW
  error: {
    flag: false,
    msg: null,
    portal: null // ✅ NEW
  }
};

export const publishreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // ---------- PROPERTY24 ----------
    case ADD_PUBLISH:
      return {
        ...state,
        loading: true,
        portal: "property24"
      };
    case ADD_PUBLISH_SUCCESS:
      return {
        ...state,
        publish: action.payload,
        loading: false,
        completed: true,
        success: true,
        portal: "property24",
        error: { flag: false, msg: null, portal: null }
      };
    case ADD_PUBLISH_FAILED:
      return {
        ...state,
        completed: true,
        loading: false,
        success: false,
        portal: "property24",
        error: { flag: true, msg: action.payload, portal: "property24" }
      };

    // ---------- API NEXUS / WEBSITE ----------
    case ADD_PUBLISH_WEBSITE:
      return {
        ...state,
        loading: true,
        portal: "apiNexus"
      };
    case ADD_PUBLISH_WEBSITE_SUCCESS:
      return {
        ...state,
        webpublish: action.payload,
        loading: false,
        completed: true,
        success: true,
        portal: "apiNexus",
        error: { flag: false, msg: null, portal: null }
      };
    case ADD_PUBLISH_WEBSITE_FAILED:
      return {
        ...state,
        loading: false,
        completed: true,
        success: false,
        portal: "apiNexus",
        error: { flag: true, msg: action.payload, portal: "apiNexus" }
      };

    // ---------- PRIVATE PROPERTY ----------
    case ADD_PRIVATE_PROP_PUBLISH:
      return {
        ...state,
        loading: true,
        portal: "privateProperty"
      };
    case ADD_PRIVATE_PROP_PUBLISH_SUCCESS:
      return {
        ...state,
        privateprop: action.payload,
        loading: false,
        completed: true,
        success: true,
        portal: "privateProperty",
        error: { flag: false, msg: null, portal: null }
      };
    case ADD_PRIVATE_PROP_PUBLISH_FAILED:
      return {
        ...state,
        loading: false,
        completed: true,
        success: false,
        portal: "privateProperty",
        error: { flag: true, msg: action.payload, portal: "privateProperty" }
      };

    // ---------- FETCHES ----------
    case FETCH_PUBLISH:
    case FETCH_PUBLISH_WEBSITE:
    case FETCH_PRIVATE_PROP_PUBLISH:
      return { ...state, loading: true };

    case FETCH_PUBLISH_SUCCESS:
      return { ...state, publish: action.payload, loading: false, completed: true, success: true };
    case FETCH_PUBLISH_WEBSITE_SUCCESS:
      return { ...state, webpublish: action.payload, loading: false, completed: true, success: true };
    case FETCH_PRIVATE_PROP_PUBLISH_SUCCESS:
      return { ...state, privateprop: action.payload, loading: false, completed: true, success: true };

    // ---------- SYNC CASES ----------
    case SYNC_TO_PROP24:
      return { ...state, loading: true, portal: "property24" };
    case SYNC_TO_PROP24_SUCCESS:
      return { ...state, loading: false, completed: true, success: true, portal: "property24" };
    case SYNC_TO_PROP24_FAILED:
      return {
        ...state,
        loading: false,
        completed: true,
        success: false,
        portal: "property24",
        error: { flag: true, msg: action.payload, portal: "property24" }
      };

    case SYNC_TO_PRIVATEPROP:
      return { ...state, loading: true, portal: "privateProperty" };
    case SYNC_TO_PRIVATEPROP_SUCCESS:
      return { ...state, loading: false, completed: true, success: true, portal: "privateProperty" };
    case SYNC_TO_PRIVATEPROP_FAILED:
      return {
        ...state,
        loading: false,
        completed: true,
        success: false,
        portal: "privateProperty",
        error: { flag: true, msg: action.payload, portal: "privateProperty" }
      };

    case SYNC_TO_WEBSITE:
      return { ...state, loading: true, portal: "apiNexus" };
    case SYNC_TO_WEBSITE_SUCCESS:
      return { ...state, loading: false, completed: true, success: true, portal: "apiNexus" };
    case SYNC_TO_WEBSITE_FAILED:
      return {
        ...state,
        loading: false,
        completed: true,
        success: false,
        portal: "apiNexus",
        error: { flag: true, msg: action.payload, portal: "apiNexus" }
      };

    // ---------- CLEAR & DEFAULT ----------
    case CLEAR_PUB_ERROR:
      return {
        ...state,
        completed: false,
        loading: false,
        success: false,
        portal: null,
        error: { flag: false, msg: null, portal: null }
      };

    default:
      return state;
  }
};
  